import React from 'react';
import LocationDetail from './locationDetail';

const OPTIONS = [
    'Existing Location with Lease',
    'Existing Location without Lease',
    'Plan on getting location',
    'No location / virtual location',
];

const LocationOption = ({ data, setData, organizationLevel, setIsLocationDetailModalOpen }) => (
    <section className="rounded-2xl border border-slate-200 bg-white p-4 shadow-sm sm:p-5 xl:col-span-2">
        <h2 className="text-base font-bold text-[#0a1445] sm:text-lg">
            What city/state will the {organizationLevel} be located in?
            <span className="text-red-600"> *</span>
        </h2>

        <div className="mt-4 grid gap-3 sm:grid-cols-2 xl:grid-cols-4">
            {OPTIONS.map(option => {
                const selected = data.locationOption === option;
                return (
                    <button
                        key={option}
                        type="button"
                        onClick={() => setData({ ...data, locationOption: option, locationDetail: {} })}
                        className={`flex min-h-[58px] items-center justify-between gap-3 rounded-xl border px-3 py-2.5 text-left text-sm font-semibold transition-all ${selected ? 'border-[#fb6635] bg-orange-50 text-[#211b4f] ring-1 ring-[#fb6635]' : 'border-slate-200 text-slate-600 hover:border-orange-200 hover:bg-orange-50/40'}`}
                    >
                        <span>{option}</span>
                        <span className={`flex h-5 w-5 flex-none items-center justify-center rounded-full border ${selected ? 'border-[#fb6635] bg-[#fb6635] text-white' : 'border-slate-300'}`}>
                            {selected && <svg className="h-3 w-3" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" d="m5 12 4 4L19 6" /></svg>}
                        </span>
                    </button>
                );
            })}
        </div>

        {data.locationOption && <LocationDetail data={data} setIsLocationDetailModalOpen={setIsLocationDetailModalOpen} />}
    </section>
);

export default LocationOption;
